import { combineReducers } from 'redux';

import Layout from "./layout";
// import VehicleList from "./vehicleList";
// import Vehicle from "./vehicle";
// import Employees from "./employees";
// import Designation from "./desgination";
// import Bit from "./bit";
// import BitDistributor from "./bitDistributors";
// import Hammer from "./hammer";
// import HammerDistributor from "./hammerDistributor";
// import Agent from "./agents";

// import PointDetails from "./pointDetails";
// import Expense from "./expense";
// import Diesel from "./diesel";

import user from "./users";
import customer from "./customer";
import customerJobCard from "./customerJobCard";
import jobcard from "./jobcard";
import dropdownReducer from "./dropdownReducer";
import report from "./report";
import product from "./product";
import userProduct from './userProduct';

import jobcardNew from "./jobcardNew";
import jobcardAmc from "./jobcardAmc";
import jobcardSer from "./jobcardSer";
import jobcardOnlineService from "./jobcardOnlineService";
import jobcardSiteService from './jobcardSiteService';

import amcStatus from "./amcStatus";
import information from './information';

import common from "./common";
import followup from './followup';

import jobcardPending from "./jobcardPending";
import attendance from "./attendance";
import documentation from "./documentation";
import reamc from "./reamc";
import offline from './offline';


export default combineReducers({
    layout: Layout,
    // vehicle: Vehicle,
    // employees: Employees,
    // bit: Bit,
    // hammer: Hammer,
    // vehicleList: VehicleList,
    // designation: Designation,
    // hammerDistributor: HammerDistributor,
    // bitDistributor: BitDistributor,
    // agent: Agent,
    // pointDetails: PointDetails,
    // expense: Expense,
    // diesel: Diesel,

    user,
    customer,
    customerJobCard,
    jobcard,
    dropdown: dropdownReducer,
    report,
    userProduct: product,
    product: userProduct,

    jobcardNew,
    jobcardAmc,
    jobcardSer,
    jobcardPending,

    amcStatus,
    reamc,
    information,

    common,
    followup,

    attendance,
    jobcardOnlineService,
    jobcardSiteService,
    documentation,
    offline
});
